import { PageHeader } from '@cuc/ui/widgets';

/** Placeholder for the Workflows Player: the step renderer replaces the body in the first feature. */
export const PlayerPage = () => (
  <PageHeader title="Workflows Player" description="The workflow steps will appear here." />
);
